/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobAction } from './jobAction';
import { NotificationRegistrationKey } from './notificationRegistrationKey';
import { StorageUnitNotificationFilter } from './storageUnitNotificationFilter';


/**
 * The request to create a storage unit notification registration
 */
export interface StorageUnitNotificationRegistrationCreateRequest { 
    storageUnitNotificationRegistrationKey: NotificationRegistrationKey;
    /**
     * The type of storage unit event in which this notification should trigger. Supported event types: STRGE_UNIT_STTS_CHG                
     */
    storageUnitEventType: string;
    storageUnitNotificationFilter: StorageUnitNotificationFilter;
    /**
     * The list of jobs to execute when this notification is triggered
     */
    jobActions?: Array<JobAction>;
    /**
     * The status of the notification registration. One of the following values: ENABLED or DISABLED. Default value is ENABLED                
     */
    notificationRegistrationStatus?: string;
}
